export enum SearchTermType {
  FreeText = 'freeText',
  PolygonId = 'polygonId',
  HotelCode = 'hotelCode',
}

interface FreeTextSearchTerm {
  type: SearchTermType.FreeText;
  freeText: string;
}

interface PolygonIdSearchTerm {
  type: SearchTermType.PolygonId;
  polygonId: number;
}

interface HotelCodeSearchTerm {
  type: SearchTermType.HotelCode;
  hotelCode: string;
}

export type SearchTerm =
  FreeTextSearchTerm | PolygonIdSearchTerm | HotelCodeSearchTerm;
